import { z } from "zod";

export const schema = z.object({
    titulo: z.string().min(1, "Título é obrigatório"),
    texto: z.string().min(1, "Texto é obrigatório"),
    data: z.string().min(10, { message: "Data é obrigatória" }),
    ativo: z.boolean(),
    presencial: z.boolean(),
    reagendar_presencial: z.boolean(),
    online: z.boolean(),
    geral: z.boolean(),
    slug_unidade: z.string().optional(),
});
